import { Blockquote, Box, Card, Inset, Link, Strong, Text } from "@radix-ui/themes";
import AddBottomSpace from "../../components/AddBottomSpace";
import AddHeadline from "../../components/AddHeadline";
import AddTopSpace from "../../components/AddTopSpace";

export default function TransversalPaths() {

  return (
    <>
      <AddTopSpace />
      <AddHeadline />
      <div className="container">

        <div className='row'>
          
          <div className='col-lg-4'>
            <div className="container py-3">
              <div className='row pb-1'>
                <div className='col'>
                  <Blockquote size="8" color>
                    Transversal Paths
                  </Blockquote>
                </div>
              </div>
            </div>
          </div>
          
          <div className='col-lg-8'>
            <div className="container py-3">
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="4">
                    The online review <Strong>Transversal Paths</Strong> intends to recover a challenging exercise of thinking: cutting across disciplines and combining intellectual capacity with artistic creativity for the sake of a differential discourse. The resulting cartography crystallizes as a possible alternative both to the self-referential tendency of academic research and to the arbitrary character of social media productions – a widening rift pointing to a social and cultural crisis on a global level. 
                  </Text>
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="4">
                    The exercise of transversality is related to a change of perception, attention, and reflection leading to another form of individual and collective attitude to the world. Its crystallization in a cultural medium aims at doing justice to some important challenges of the XXI century, such as the geopolitical reconfiguration of the globe and its cultural effects, the complex civilizational problematic behind the ecological crisis, the extended decolonization process and its heritage, and the voice of marginalized traditions rendered audible by new impulses in the human sciences.
                  </Text> 
                </div>
              </div>
            </div>
          </div>

        </div>





        <div className='row border-top'>
          
          <div className='col-lg-4'>
            <div className="container py-3">
              <div className='row pb-1'>
                <div className='col'>
                  <Inset clip="padding-box" side="top" pb="current">
                    <img
                      src="https://www.shadvala.org/img/transversal-paths-05.jpg"
                      alt="Vision"
                      style={{
                        display: 'block',
                        objectFit: 'cover',
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'var(--gray-5)',
                      }}
                    />
                  </Inset>
                </div>
              </div>
            </div>
          </div>
          
          <div className='col-lg-8'>
            <div className="container py-3">
              <div className='row pb-1'>
                <div className='col'>
                  <Text as="p" mb="5" size="6">
                    Transversal Paths
                  </Text>
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" mx="1" size="3">
                    <Strong>
                      Issue 5, July 2026
                    </Strong> &nbsp;&nbsp;
                    <Link   href="https://www.shadvala.org/pdf/Transversal-Paths-Issue-05.pdf" target="_blank">
                      Download PDF (2.4 MB) &nbsp;
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.50005 1.04999C7.74858 1.04999 7.95005 1.25146 7.95005 1.49999V8.41359L10.1819 6.18179C10.3576 6.00605 10.6425 6.00605 10.8182 6.18179C10.994 6.35753 10.994 6.64245 10.8182 6.81819L7.81825 9.81819C7.64251 9.99392 7.35759 9.99392 7.18185 9.81819L4.18185 6.81819C4.00611 6.64245 4.00611 6.35753 4.18185 6.18179C4.35759 6.00605 4.64251 6.00605 4.81825 6.18179L7.05005 8.41359V1.49999C7.05005 1.25146 7.25152 1.04999 7.50005 1.04999ZM2.5 10C2.77614 10 3 10.2239 3 10.5V12C3 12.5539 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2239 12.2239 10 12.5 10C12.7761 10 13 10.2239 13 10.5V12C13 13.1041 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2239 2.22386 10 2.5 10Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg> 
                    </Link>
                  </Text> 
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" mx="0" size="4">
                    <Strong>
                      Adrián Navigante                   
                    </Strong> <br/>
                    HOSPITALITY AND ALTERITY:<br/> 
                    TOBIE NATHAN, THE FAITHFUL<br/> 
                    APOSTATE
                    <br/><br/>

                    Interview with <Strong>Roberto Beneduce</Strong> 
                    <br/>
                    UNSUBMISSIVE THINKING:<br/> 
                    THE SCANDAL OF<br/> 
                    ETHNOPSYCHIATRY (PART 1)<br/> 
                    by <strong>Adrián Navigante</strong>
                    <br/><br/>

                    <Strong>Alessandro Montefameglio</Strong> <br/>
                    BAROQUE AND MUD
                    <br/><br/>

                    Interview with <Strong>Shãwãhu Timá (Vovô João)</Strong> <br/>
                    and <Strong>Tika Matxuru Wanipashutiya</Strong>
                    <br/>
                    YAWANAWA HEALERS<br/>
                    by <strong>Amanda Viana de Sousa</strong>
                  </Text> 
                </div>
              </div>

              
            </div>
          </div>

        </div>





        <div className='row border-top'>
          
          <div className='col-lg-4'>
            <div className="container py-3">
              <div className='row pb-1'>
                <div className='col'>
                  <Inset clip="padding-box" side="top" pb="current">
                    <img
                      src="https://www.shadvala.org/img/transversal-paths-04.jpg"
                      alt="Vision"
                      style={{
                        display: 'block',
                        objectFit: 'cover',
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'var(--gray-5)',
                      }}
                    />
                  </Inset>
                </div>
              </div>
            </div>
          </div>
          
          <div className='col-lg-8'>
            <div className="container py-3">
              <div className='row pb-1'>
                <div className='col'>
                  <Text as="p" mb="5" size="6">
                    Transversal Paths
                  </Text>
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" mx="1" size="3">
                    <Strong>
                      Issue 4, December 2025
                    </Strong> &nbsp;&nbsp;
                    <Link   href="https://www.shadvala.org/pdf/Transversal-Paths-Issue-04.pdf" target="_blank">
                      Download PDF (2.8 MB) &nbsp;
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.50005 1.04999C7.74858 1.04999 7.95005 1.25146 7.95005 1.49999V8.41359L10.1819 6.18179C10.3576 6.00605 10.6425 6.00605 10.8182 6.18179C10.994 6.35753 10.994 6.64245 10.8182 6.81819L7.81825 9.81819C7.64251 9.99392 7.35759 9.99392 7.18185 9.81819L4.18185 6.81819C4.00611 6.64245 4.00611 6.35753 4.18185 6.18179C4.35759 6.00605 4.64251 6.00605 4.81825 6.18179L7.05005 8.41359V1.49999C7.05005 1.25146 7.25152 1.04999 7.50005 1.04999ZM2.5 10C2.77614 10 3 10.2239 3 10.5V12C3 12.5539 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2239 12.2239 10 12.5 10C12.7761 10 13 10.2239 13 10.5V12C13 13.1041 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2239 2.22386 10 2.5 10Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg> 
                    </Link>
                  </Text> 
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" mx="0" size="4">
                    <Strong>
                      Adrián Navigante                   
                    </Strong> <br/>
                    THE PSYCHOSOCIAL LIFE OF<br/> 
                    <i>DAIMONES</i>
                    <br/><br/>

                    <Strong>Raquel Romberg</Strong> <br/>
                    CREOLE FICTIONS AND <br/> 
                    FRICTIONS: RITUAL POIESIS <br/> 
                    AND TRANSMUTATION AT <br/> 
                    UNPREDICTABLE INTERSTICES
                    <br/><br/>

                    Interview with <Strong>PAUL STOLLER</Strong> 
                    <br/>
                    SHARED ANTHROPOLOGY:<br/>
                    THE OTHER'S WAY (PART 2)<br/>
                    by <strong>Adrián Navigante</strong>
                    <br/><br/>

                    <Strong>Edward Bever</Strong> <br/>
                    MAGIC AND REALITY
                  </Text> 
                </div>
              </div>

              
            </div>
          </div>

        </div>










        <div className='row border-top'>
          
          <div className='col-lg-4'>
            <div className="container py-3">
              <div className='row pb-1'>
                <div className='col'>
                  <Inset clip="padding-box" side="top" pb="current">
                    <img
                      src="https://www.shadvala.org/img/transversal-paths-03.jpg"
                      alt="Vision"
                      style={{
                        display: 'block',
                        objectFit: 'cover',
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'var(--gray-5)',
                      }}
                    />
                  </Inset>
                </div>
              </div>
            </div>
          </div>
          
          <div className='col-lg-8'>
            <div className="container py-3">
              <div className='row pb-1'>
                <div className='col'>
                  <Text as="p" mb="5" size="6">
                    Transversal Paths
                  </Text>
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" mx="1" size="3">
                    <Strong>
                      Issue 3, July 2025
                    </Strong> &nbsp;&nbsp;
                    <Link   href="https://www.shadvala.org/pdf/Transversal-Paths-Issue-03.pdf" target="_blank">
                      Download PDF (2.3 MB) &nbsp;
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.50005 1.04999C7.74858 1.04999 7.95005 1.25146 7.95005 1.49999V8.41359L10.1819 6.18179C10.3576 6.00605 10.6425 6.00605 10.8182 6.18179C10.994 6.35753 10.994 6.64245 10.8182 6.81819L7.81825 9.81819C7.64251 9.99392 7.35759 9.99392 7.18185 9.81819L4.18185 6.81819C4.00611 6.64245 4.00611 6.35753 4.18185 6.18179C4.35759 6.00605 4.64251 6.00605 4.81825 6.18179L7.05005 8.41359V1.49999C7.05005 1.25146 7.25152 1.04999 7.50005 1.04999ZM2.5 10C2.77614 10 3 10.2239 3 10.5V12C3 12.5539 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2239 12.2239 10 12.5 10C12.7761 10 13 10.2239 13 10.5V12C13 13.1041 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2239 2.22386 10 2.5 10Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg> 
                    </Link>
                  </Text> 
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" mx="0" size="4">
                    <Strong>
                      Adrián Navigante                   
                    </Strong> <br/>
                    GEORGES LAPASSADE’S<br/> 
                    TRANSVERSALIST DETOUR:<br/>
                    A NOTE ON “MACUMBA” AND<br/>
                    “MINOR LITERATURE”
                    <br/><br/>

                    <Strong>Emma Lavinia Bon</Strong> <br/>
                    THE INNER TEMPLE AND THE<br/> 
                    CENTER(S) OF LIFE: PSYCHIC,<br/> 
                    MATERIAL, AND SACRED SPACE
                    <br/><br/>

                    Interview with <Strong>PAUL STOLLER</Strong> 
                    <br/>
                    SHARED ANTHROPOLOGY:<br/>
                    THE OTHER'S WAY (PART 1)<br/>
                    by <strong>Adrián Navigante</strong>
                    <br/><br/>

                    <Strong>Gioia Lussana</Strong> <br/>
                    YOGA: THE ART OF<br/> 
                    CONTEMPLATION THAT<br/> 
                    BECOMES A FESTAL<br/> 
                    CELEBRATION
                  </Text> 
                </div>
              </div>

              
            </div>
          </div>

        </div>









        <div className='row border-top'>
          
          <div className='col-lg-4'>
            <div className="container py-3">
              <div className='row pb-1'>
                <div className='col'>
                  <Inset clip="padding-box" side="top" pb="current">
                    <img
                      src="https://www.shadvala.org/img/transversal-paths-02.jpg"
                      alt="Vision"
                      style={{
                        display: 'block',
                        objectFit: 'cover',
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'var(--gray-5)',
                      }}
                    />
                  </Inset>
                </div>
              </div>
            </div>
          </div>
          
          <div className='col-lg-8'>
            <div className="container py-3">
              <div className='row pb-1'>
                <div className='col'>
                  <Text as="p" mb="5" size="6">
                    Transversal Paths
                  </Text>
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" mx="1" size="3">
                    <Strong>
                      Issue 2, December 2024
                    </Strong> &nbsp;&nbsp;
                    <Link   href="https://www.shadvala.org/pdf/Transversal-Paths-Issue-02.pdf" target="_blank">
                      Download PDF (0.8 MB) &nbsp;
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.50005 1.04999C7.74858 1.04999 7.95005 1.25146 7.95005 1.49999V8.41359L10.1819 6.18179C10.3576 6.00605 10.6425 6.00605 10.8182 6.18179C10.994 6.35753 10.994 6.64245 10.8182 6.81819L7.81825 9.81819C7.64251 9.99392 7.35759 9.99392 7.18185 9.81819L4.18185 6.81819C4.00611 6.64245 4.00611 6.35753 4.18185 6.18179C4.35759 6.00605 4.64251 6.00605 4.81825 6.18179L7.05005 8.41359V1.49999C7.05005 1.25146 7.25152 1.04999 7.50005 1.04999ZM2.5 10C2.77614 10 3 10.2239 3 10.5V12C3 12.5539 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2239 12.2239 10 12.5 10C12.7761 10 13 10.2239 13 10.5V12C13 13.1041 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2239 2.22386 10 2.5 10Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg> 
                    </Link>
                  </Text> 
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" mx="0" size="4">
                    <Strong>
                      Adrián Navigante                   
                    </Strong> <br/>
                    EXTENDED TRANSVERSALITY<br/> 
                    ON FÉLIX GUATTARI’S<br/> 
                    “ALCHEMICAL LABORATORY”
                    <br/><br/>

                    Interview with <Strong>Michael Houseman</Strong> 
                    <br/>
                    UNDERSTANDING THE PLURI-<br/>
                    VERSE OF RITUALS<br/>
                    by <strong>Adrián Navigante</strong>
                    <br/><br/>

                    <Strong>Marika Moisseeff</Strong> <br/>
                    WHAT THE BEWITCHING OF MY 
                    GRANDPARENTS' COWS <br/>TAUGHT 
                    ME ABOUT RELATIONSHIPS 
                    BETWEEN<br/> 
                    TRADITIONAL FRENCH 
                    PEASANTS AND OTHER-THAN- 
                    HUMANS
                    <br/><br/>

                    Interview with <Strong>Olívio Jekupé</Strong> 
                    <br/>
                    NATIVE LITERATURE AS A FORM<br/>
                    OF INDIGENOUS RESISTANCE<br/>
                    by <strong>Amanda Viana</strong>


                  </Text> 
                </div>
              </div>

              
            </div>
          </div>

        </div>


        
        <div className='row border-top'>
          
          <div className='col-lg-4'>
            <div className="container py-3">
              <div className='row pb-1'>
                <div className='col'>
                  <Inset clip="padding-box" side="top" pb="current">
                    <img
                      src="https://www.shadvala.org/img/transversal-paths-01.jpg"
                      alt="Vision"
                      style={{
                        display: 'block',
                        objectFit: 'cover',
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'var(--gray-5)',
                      }}
                    />
                  </Inset>
                </div>
              </div>
            </div>
          </div>
          
          <div className='col-lg-8'>
            <div className="container py-3">
              <div className='row pb-1'>
                <div className='col'>
                  <Text as="p" mb="5" size="6">
                    Transversal Paths
                  </Text>
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" mx="1" size="3">
                    <Strong>
                      Issue 1, July 2024
                    </Strong> &nbsp;&nbsp;
                    <Link   href="https://www.shadvala.org/pdf/Transversal-Paths-Issue-01.pdf" target="_blank">
                      Download PDF (1.7 MB) &nbsp;
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.50005 1.04999C7.74858 1.04999 7.95005 1.25146 7.95005 1.49999V8.41359L10.1819 6.18179C10.3576 6.00605 10.6425 6.00605 10.8182 6.18179C10.994 6.35753 10.994 6.64245 10.8182 6.81819L7.81825 9.81819C7.64251 9.99392 7.35759 9.99392 7.18185 9.81819L4.18185 6.81819C4.00611 6.64245 4.00611 6.35753 4.18185 6.18179C4.35759 6.00605 4.64251 6.00605 4.81825 6.18179L7.05005 8.41359V1.49999C7.05005 1.25146 7.25152 1.04999 7.50005 1.04999ZM2.5 10C2.77614 10 3 10.2239 3 10.5V12C3 12.5539 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2239 12.2239 10 12.5 10C12.7761 10 13 10.2239 13 10.5V12C13 13.1041 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2239 2.22386 10 2.5 10Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg> 
                    </Link>
                  </Text> 
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" mx="0" size="4">
                    <Strong>
                      Adrián Navigante                   
                    </Strong> <br/>
                    THE POIETIC SIGNIFICANCE
                    OF THE LABYRINTH:<br/>
                    NOTES ON THE SYMPTOMATOLOGY OF A DYING CULTURE
                    <br/><br/>
                    Interview with <Strong>Graham Harvey</Strong> by Adrián Navigante<br/>
                    ANIMISM AND PAGANISM:
                    TWO SIDES OF THE SAME “TURN”?
                    <br/><br/>
                    <Strong>Graham Harvey</Strong> <br/>
                    AN ANIMIST MANIFESTO
                    
                    <br/><br/>
                    <Strong>Jeffrey J. Kripal</Strong><br/>
                    LOSING WORLDS TO THINK AFTER THEM: <br/>
                    TRANSVERSAL REFLECTIONS FROM A COMPARATIVE CLASSROOM
                    
                    <br/><br/>
                    <Strong>Marcello Barison</Strong><br/>
                    “AVIS, JASMIN VARNĀ NA Ā AST, DADARKA AKVAMS”<br/>
                    MOUNTED INDO-EUROPEAN ARMY

                  </Text> 
                </div>
              </div>

              
            </div>
          </div>

        </div>





      </div>
      
      <AddBottomSpace />
    </>
  )
}
